function resolveContentMenuAnchor(linkId) {
  const id = linkId?.trim().replace(/^#/, '');
  if (!id) return null;

  return document.getElementById(id) ? id : null;
}

function getAnchorElement(linkId) {
  const anchorId = resolveContentMenuAnchor(linkId);
  return anchorId ? document.getElementById(anchorId) : null;
}

function anchorContainsReco(anchor, recoElement) {
  if (!anchor || !recoElement) return false;
  return anchor === recoElement || anchor.contains(recoElement);
}

function initProductContentMenu(root = document) {
  const sections = root.querySelectorAll(
    '.product-content-menu-section:not([data-sticky-menu-clone])',
  );

  sections.forEach((menuSection) => {
    const list = menuSection.querySelector('.product-content-menu__list');
    if (!list) return;

    list.querySelectorAll('[data-menu-item]').forEach((item) => {
      const anchorId = resolveContentMenuAnchor(item.dataset.linkId);

      if (!anchorId) {
        item.remove();
        return;
      }

      const link = item.querySelector('.product-content-menu__link');
      if (link) link.setAttribute('href', `#${anchorId}`);
      item.hidden = false;
    });

    const hasItems = list.querySelector('.product-content-menu__item');
    menuSection.classList.toggle('product-content-menu-section--empty', !hasItems);
  });

  document.dispatchEvent(new CustomEvent('product-content-menu:ready'));
}

function refreshEmptyState(menuSection) {
  if (!menuSection) return;

  const list = menuSection.querySelector('.product-content-menu__list');
  const hasItems = list?.querySelector('.product-content-menu__item');

  if (menuSection.hasAttribute('data-sticky-menu-clone')) {
    if (!hasItems) menuSection.remove();
    return;
  }

  menuSection.classList.toggle('product-content-menu-section--empty', !hasItems);
}

function updateRecoCounts(event) {
  const { count } = event.detail;
  const recoElement = event.target;

  document.querySelectorAll('[data-reco-count]').forEach((el) => {
    const menuItem = el.closest('[data-menu-item]');
    const anchor = getAnchorElement(menuItem?.dataset.linkId);

    if (!anchorContainsReco(anchor, recoElement)) return;

    if (count > 0) {
      el.textContent = `(${count}x)`;
      el.hidden = false;
      return;
    }

    menuItem?.remove();
  });

  document
    .querySelectorAll('.product-content-menu-section:not([data-sticky-menu-clone])')
    .forEach(refreshEmptyState);
  document.dispatchEvent(new CustomEvent('product-content-menu:ready'));
}

document.addEventListener('DOMContentLoaded', () => initProductContentMenu());
document.addEventListener('exponea-reco:loaded', updateRecoCounts);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector?.('.product-content-menu-section')) {
    initProductContentMenu(event.target);
  }
});
